// @flow

import React from 'react'
import Appear from './Appear'
import Container from './Container'
import SectionTitle from './SectionTitle'

type Props = {
  title: string,
  children: any,
}

const Communications = ({ title, children }: Props) => {
  return (
    <div className="bg-light-gray">
      <SectionTitle title={title} />
      <Appear>
        <Container className="pb-16">
        <div className="flex flex-col h-full shadow-xl">
          <div className="h-4 border-b-4 border-dashed border-light-gray bg-light-green" />
          <div key="content" className="flex-1 pt-6 pb-12 md:pb-8 bg-light-green">
            <div
              key="content-container"
              className="px-5 text-base text-center md:px-8 md:text-left"
            >
              {children}
            </div>
          </div>
        </div>
        </Container>
      </Appear>
    </div>
  )
}

export default Communications
